import type { ContractImportJobsQueryParams } from './useQueryContractImportJobs';

import type { UUID } from '~/types/common';

/**
 * Query key factory for contract-import-job-related queries.
 */
export const queryKeysContractImportJob = {
  base: () => 'contractImportJobs' as const,
  get: (jobId: UUID) =>
    [queryKeysContractImportJob.base(), 'detail', { jobId }] as const,
  getAll: (queryParams?: Partial<ContractImportJobsQueryParams>) =>
    [queryKeysContractImportJob.base(), 'list', queryParams].filter(Boolean),
} as const;
